import { render, staticRenderFns } from "./MaterialManage.vue?vue&type=template&id=94c6f4c6"
import script from "./MaterialManage.vue?vue&type=script&lang=js"
export * from "./MaterialManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports